<template>
  <profile-main>
    <profile-header activeMenu="setting" slot="profileNavigation" />
    <loading-container :loading="apiKeyLoading">
      <div v-if="apiKeyList.length === 0" class="text-center">
        <span>You don't have any API Key</span>
      </div>
      <div v-else>
        <div class="table-responsive">
          <table
            class="table table-striped dataTable no-footer"
            style="width: 100%;"
          >
            <thead>
              <tr>
                <th>STORE ID</th>
                <th>KEY</th>
                <th>GENERATED AT</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="apiKey in apiKeyList" :key="apiKey.id">
                <td>{{ apiKey.storeId ? apiKey.storeId : 'n/a' }}</td>
                <td>{{ apiKey.apiKey }}</td>
                <td>{{ apiKey.createdAt | dateDisplay }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

<!--      <div class="card">-->
<!--        <h5 class="card-title">Referral setting</h5>-->
<!--        <div class="d-flex no-block align-items-start m-t-20 m-b-20">-->
<!--          <form @submit.prevent="() => {}" class="w-100">-->
<!--            <div class="row d-flex align-items-center">-->
<!--              <div class="col-md-8">-->
<!--                <div class="form-group">-->
<!--                  <input-text-->
<!--                    type="text"-->
<!--                    name="referral"-->
<!--                    :value="form.referralCode"-->
<!--                    label="Referral code"-->
<!--                    placeholder="Ex. CF1019202"-->
<!--                    @input="-->
<!--                      text => {-->
<!--                        setField({ key: 'referralCode', value: text });-->
<!--                      }-->
<!--                    "-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-md-4">-->
<!--                <referral-status :status="form.referralCodeStatus" :expiredDate="form.referralCodeExpired | dateDisplay" class="absolute" v-if="form.referralCode"></referral-status>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-md-12">-->
<!--                <div class="form-group">-->
<!--                  <form-button-->
<!--                    class="btn-block"-->
<!--                    type="primary"-->
<!--                    :click="() => submitChangeReferralCode()"-->
<!--                    :loading="autoPaymentLoading"-->
<!--                    input-type="button"-->
<!--                    text="Save"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </form>-->
<!--        </div>-->
<!--      </div>-->
    </loading-container>
  </profile-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import InputText from '@/components/Form/InputText';
import RadioButton from '@/components/Form/RadioButton';
import FormButton from '@/components/Form/FormButton';
import LinkButton from '@/components/Misc/LinkButton';
import LoadingContainer from '@/components/Misc/LoadingContainer';
import ReferralStatus from '@/components/Common/ReferralStatus'
import ProfileHeader from './components/Header';
import ProfileMain from './components/Main';

export default {
  name: 'Setting',
  components: {
    InputText,
    RadioButton,
    FormButton,
    LinkButton,
    ReferralStatus,
    LoadingContainer,
    ProfileHeader,
    ProfileMain,
  },
  beforeMount() {
    this.loadApiKeyList();
    this.getUserInfo();
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      form: 'auth/form',
      apiKeyLoading: 'apiKey/loading',
      autoPaymentLoading: 'auth/autoPaymentLoading',
      apiKeyList: 'apiKey/list',
    }),

    currentUser() {
      return this.user || {};
    },
    currentRole() {
      return this.currentUser.role;
    },
  },
  methods: {
    ...mapActions({
      loadApiKeyList: 'apiKey/getList',
      setField: 'auth/setField',
      getUserInfo: 'auth/getUserInfo',
      submitChangeReferralCode: 'auth/submitChangeReferralCode',
    }),
  },
};
</script>
